import { React, DomeComponent, DomeManipulator, DomeRouter } from "@lexriver/dome";
import css from './TopBarIcon.m.scss'
import cssAnimation from '../Animation.m.scss'
import { EnumIconNames } from "../enums/EnumIconNames";
import { UrlGenerator } from "../UrlGenerator";
import { GlobalFavorites } from "../GlobalFavorites";
import { GlobalUser } from "../GlobalUser";
import { IconUser } from "./IconUser";

interface Attrs{

}

export class ProfileTopIcon extends DomeComponent<Attrs>{
    //counter:number = 0
    refContainer!:HTMLDivElement

    render(){
        return (
            <div class={css.container} ref={ref => { this.refContainer = ref; }} onClick={async () => await this.onClickAsync()}></div>
        )
    }
    async afterRender(){
        // GlobalState.basketSmallDiv = this.rootElement as HTMLDivElement
        this.scheduleUpdate()
        GlobalUser.eventUserLoggedIn.subscribe(() => {
            if(DomeManipulator.isInDom(this.refContainer) == false) return {unsubscribe:true}
            this.scheduleUpdate()
        })

        GlobalUser.eventUserLoggedOut.subscribe(() => { //TODO: merge to one function?
            if(DomeManipulator.isInDom(this.refContainer) == false) return {unsubscribe:true}
            this.scheduleUpdate()
        })

        GlobalUser.loggedInUserO.eventOnChange.subscribe(() => {
            this.scheduleUpdate()
        })

        
        this.scheduleUpdate()

    }

    async onClickAsync(){
        // alert('TODO')
        if(await GlobalUser.checkIfLoggedInAsync()){
            DomeRouter.navigate(UrlGenerator.profile)
        } else {
            DomeRouter.navigate(UrlGenerator.login)
        }
    }

    async updateAsync(){
        //this.counter++
        // const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        // const cBasketStats = await basket.getStatsAsync()
        //console.log('))) cBasketStats=', cBasketStats)
        
        await DomeManipulator.replaceAllChildrenAsync(
            this.refContainer, 
            this.renderIcon(),
            undefined,
            {cssClassName:cssAnimation.basketHeader, timeMs: 300}
            )
        
    }

    renderIcon(){
        return (
            <div class={css.iconContainer}>
                {/* <div>counter={this.counter}</div> */}
                <IconUser />
                {/* <span class={EnumIconNames.UserClear} style={{ fontSize: "19px", margin: '2px 3px' }}  ></span> */}
                {/* <span class={EnumIconNames.UserClear2} style={{ fontSize: "20px", margin: '0 3px' }}  ></span> */}
                {/* <span class={EnumIconNames.UserClear3} style={{ fontSize: "20px", margin: '0 3px' }}  ></span> */}
            </div>
                
        )

    }
    
}

